import { combineReducers } from 'redux'

const defaultParams = {
    isFetching: false,
    isFetched: false,
}


function list(state = [], action) {
    if (action.type === 'FETCHED_UPLOADED_FILES') {
        return Array.isArray(action.payload) ? action.payload : []
    }
    if (action.type === 'RESET_UPLOADED_FILES') {
        return []
    }
    return state
}

function params(state = defaultParams, action) {
    if (action.type === 'FETCH_UPLOADED_FILES') {
        return { ...state, isFetching: true, isFetched: false }
    }
    if (action.type === 'FETCHED_UPLOADED_FILES') {
        return { ...state, isFetching: false, isFetched: true }
    }
    if (action.type === 'RESET_UPLOADED_FILES') {
        return defaultParams
    }
    return state
}


const uploader = combineReducers({
    list,
    params,
})

export default uploader
